import "./BathroomRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Included from "./sections/Included";
import CostTimeline from "./sections/CostTimeline";
import RequestEstimate from "./sections/RequestEstimate";
import Faq from "./sections/Faq";
import StartProject from "./sections/StartProject";
import Footer from "@/reusable_sections/Footer";
import RelatedGuides from "./sections/RelatedGuides";
export default function BathroomRemodelingPage() {
  return <div>
      <Header />
      <Hero />
      <Included />
      <CostTimeline />
      <RequestEstimate />
      <Faq />
      <StartProject />
      <RelatedGuides />
      <Footer />
    </div>;
}